import { type BillingQueries, defBillingQueries } from '@kizen/query/billing';
import AxiosService from '__services/AxiosService';

const queries: BillingQueries = defBillingQueries(AxiosService);

export const getSummaryUsageQuery: BillingQueries['getSummaryUsageQuery'] =
  queries.getSummaryUsageQuery;

export const getBillingLicensePlansQuery: BillingQueries['getBillingLicensePlansQuery'] =
  queries.getBillingLicensePlansQuery;

export const getBusinessLicenseQuery: BillingQueries['getBusinessLicenseQuery'] =
  queries.getBusinessLicenseQuery;

export const getPaymentMethodsQuery: BillingQueries['getPaymentMethodsQuery'] =
  queries.getPaymentMethodsQuery;

export const createSetupIntentQuery: BillingQueries['createSetupIntentQuery'] =
  queries.createSetupIntentQuery;

export const getScheduledBusinessLicensesQuery: BillingQueries['getScheduledBusinessLicensesQuery'] =
  queries.getScheduledBusinessLicensesQuery;
